import React, { useState, useEffect  } from 'react';
import styles from './EditModal.module.css';
import axios from "../../../../utils/api/axios";
import { DialogEnum, showDialog } from '../../../../utils/dialog/Dialog';
import { IAM_SERVER_MULTIFACTORPOLICY, IAM_SERVER_UNIFIEDPROFILE } from '../../../../utils/Config';
import { getCookie } from '../../../../utils/cookies/cookies';

function PushAuthModal({ onClose, onSuccess, otpDevices }) {
  const [step, setStep] = useState("verify"); // 'verify' 또는 'register'
  const [currentPw, setCurrentPw] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [showSecretKey, setShowSecretKey] = useState(false); // 🔑 Secret Key 표시 여부 상태

  const [localOtpDevices, setLocalOtpDevices] = useState(otpDevices);

  // useEffect(() => {
  //   if (localOtpDevices.length > 0) {
  //     setStep("manage");
  //   }
  // }, [localOtpDevices]);

  const getDaysAgo = (dateString) => {
    const registeredDate = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - registeredDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays}일 전`;
  };

  // 🔑 모달이 열릴 때 디바이스 목록을 기반으로 다음 단계 결정
  const verifyPassword = async () => {
    const userId = getCookie("user_id");
    try {
      const res = await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
        password: currentPw,
        unifiedProfileId: userId
      });

      const data = res.data;
      if (data.code === 200 || data.success === true) {
        setStep("manage"); // 비밀번호 확인 성공 시 관리 단계로 이동
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
      }
    } catch (err) {
      showDialog(DialogEnum.DEFAULT, "오류", "서버 오류가 발생했습니다.");
    }
  };

  // 🔑 삭제 버튼 핸들러
  const handleDeleteDevice = async (deviceId) =>  {
   const userId = getCookie("user_id");
   try {
        const res = await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/otp/delete-device`, {
          unifiedProfileId: userId,
          deviceId: deviceId  
         });
         
        // 🔑 성공 시 부모 컴포넌트의 상태를 업데이트하는 함수 호출
        if (res.data.data) {
          const updatedDevices = res.data.data ? res.data.data.factorPolicyMeta.devices : [];
          setLocalOtpDevices(updatedDevices);
          showDialog(DialogEnum.DEFAULT, "알림", "기기가 삭제되었습니다.");
        } else {
          // 정책이 삭제된 경우 (마지막 기기였을 때)
          showDialog(DialogEnum.DEFAULT, "알림", "마지막 기기가 삭제되어 OTP 설정이 해제되었습니다.");
        }
    } catch (error) {
        showDialog(DialogEnum.DEFAULT, "오류", "기기 삭제 중 오류가 발생했습니다.");
    }

  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>앱 푸시 알림 기기 목록</h3>

        {step === "verify" && (
          <>
            <input
              className={styles.modalInput}
              type="password"
              value={currentPw}
              onChange={(e) => setCurrentPw(e.target.value)}
              placeholder="현재 비밀번호 입력"
            />
            <div className={styles.modalButtonRow}>
              <button className={styles.cancelBtn} onClick={onClose}>취소</button>
              <button className={styles.saveBtn} onClick={verifyPassword}>확인</button>
            </div>
          </>
        )}

        {/* 2단계: 기기 관리 및 등록 */}
        {step === "manage" && (
          <div>
            <p style={{ fontWeight: 'bold' }}>등록된 기기 목록 ({localOtpDevices.length}대)</p>
            
            <ul className={styles.deviceList}>
              {localOtpDevices.length > 0 ? (
                localOtpDevices.map((device, index) => (
                  <li key={index} className={styles.deviceItem}>
                    <div className={styles.deviceInfo}>
                      <p><strong>기기명:</strong> {device.deviceName}</p>
                      <p><strong>등록일:</strong> {getDaysAgo(device.registeredAt)}</p>
                    </div>
                    {/* <button 
                      className={styles.deleteButton}
                      onClick={() => handleDeleteDevice(device.deviceId)}
                    >
                      삭제
                    </button> */}
                  </li>
                ))
              ) : (
                <p style={{ marginTop: '10px' }}>등록된 기기가 없습니다.</p>
              )}
            </ul>
            
            <hr className={styles.listDivider} />
            
            {/* 🔑 '추가 기기 등록' 버튼과 '닫기' 버튼 */}
            <div className={styles.modalButtonRow}>
                    <button className={styles.cancelBtn} onClick={onClose}>닫기</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PushAuthModal;
